import React from "react";
import "../animations/animate.css";
import AnimatedBody from "../animations/AnimatedBody";
import AnimatedTitle from "../animations/AnimatedTitle";

const About = () => {
  return (
    <section
      className="relative z-10 w-full items-center justify-center overflow-hidden bg-[#0E1016] bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
      id="about"
    >
      <div className="mx-auto flex flex-col items-center justify-center lg:max-w-[1212.8px]">
        <AnimatedTitle
          text={"Who am I ?"}
          className={
            "mb-10 text-center text-[32px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-left sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
          }
          wordSpace={"mr-[14px]"}
          charSpace={"mr-[0.001em]"}
        />
        <div className="mx-auto flex w-[100%] flex-col lg:max-w-[1200px] lg:flex-row lg:gap-20">
          <div className="mb-10 flex w-[100%] flex-col gap-4 text-lg font-medium  leading-relaxed tracking-wide text-[#e4ded7]">
            <AnimatedBody text="Frontend Engineer with 5+ years of experience building high-impact applications in AI, Martech, and crypto. I specialize in React.js, Next.js, TypeScript, micro-frontends, and scalable architecture." />
            <AnimatedBody
              delay={0.1}
              text="Across roles at Lopti AI, RD Station, and blockchain startups, I've led critical frontend initiatives, guided engineering best practices, and delivered performance-driven solutions — cutting load times by 94.6%, reducing bugs by 72%, and accelerating development with reusable systems and design-system-driven components."
            />
            <AnimatedBody
              delay={0.2}
              text="I thrive in cross-functional environments and enjoy creating user-focused, reliable, and well-architected products."
            />
            <AnimatedBody
              delay={0.3}
              text="On my spare time, I've been dedicated to sharing knowledge and tips about Web Development, career growth, and events with other developers through my educational pages with over 15k people on Instagram and TikTok (@codewithsah)."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
